import type { LobbyState } from './lobbyStore.types';

export const charCreationSlice: Pick<
  LobbyState,
  'charCreationAvailable' | 'setCharCreationAvailable'
> = {
  charCreationAvailable: false,
  setCharCreationAvailable: (available: boolean) => ({ charCreationAvailable: available }),
};
